import { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

export const getPlaybookScoringConfigType = (isSharedWithAccount: boolean): ScoringConfigType =>
    isSharedWithAccount ? ScoringConfigType.Account : ScoringConfigType.User;
